import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@pella/sash-framework';
import { CTA } from '../../';

import './index.css';

const StarRatings = ({ totalReviews, overallRating, hideTotal = false, hideRating = false, ratingsLink, className }) => {
	if (!totalReviews || !overallRating) return null;

	return (
		<div className={`starRatings relative inline-flex items-center ${className || ''}`}>
			{overallRating && !hideRating && <p className='mr-2 text-sm font-semibold !leading-none md:mr-3 md:text-2xl'>{overallRating}</p>}

			<div className='grid grid-cols-1 grid-rows-1'>
				<span
					className='col-[1] row-[1] flex flex-row overflow-hidden whitespace-nowrap text-black [&>*]:text-lg [&>*]:!leading-none md:[&>*]:text-3xl'
					style={{ width: `calc( ( ${overallRating} / 5 ) * 100% )` }}
				>
					<Icon name='star' fill={1} />
					<Icon name='star' fill={1} />
					<Icon name='star' fill={1} />
					<Icon name='star' fill={1} />
					<Icon name='star' fill={1} />
				</span>

				<span className='col-[1] row-[1] flex flex-row overflow-hidden whitespace-nowrap text-black [&>*]:text-lg [&>*]:!leading-none md:[&>*]:text-3xl'>
					<Icon name='star_outline' />
					<Icon name='star_outline' />
					<Icon name='star_outline' />
					<Icon name='star_outline' />
					<Icon name='star_outline' />
				</span>
			</div>

			{totalReviews &&
				!hideTotal &&
				((ratingsLink?.[0] && (
					<CTA
						className='ml-2 text-sm !leading-none decoration-black decoration-1 md:ml-3 md:text-sm'
						data={ratingsLink[0]}
						renderAs='link'
					>
						{totalReviews} Reviews
					</CTA>
				)) || <p className='ml-2 text-sm !leading-none md:ml-3 md:text-sm'>{totalReviews} Reviews</p>)}
		</div>
	);
};

StarRatings.propTypes = {
	totalReviews: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	overallRating: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	hideTotal: PropTypes.bool,
	hideRating: PropTypes.bool,
	ratingsLink: PropTypes.array,
	className: PropTypes.string,
};

export default StarRatings;
